import { forwardRef, memo } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

import { cx } from '@/utils/cx';

import { useScrollContext } from '../HeaderContext';

import styles from './HeaderContent.module.scss';

import type { VisibleOn } from '../types';

export interface HeaderContentProps extends ComponentPropsWithoutRef<'div'> {
  /** 스크롤 시에만 표시 (CSS class 토글, DOM 항상 유지) */
  showOnScroll?: boolean;
  /** 특정 디바이스에서만 노출. 미지정 = 항상 노출 */
  visibleOn?: VisibleOn;
}

export const HeaderContent = memo(
  forwardRef<HTMLDivElement, HeaderContentProps>(({ children, className, visibleOn, showOnScroll, ...rest }, ref) => {
    const { isScrolled } = useScrollContext();
    const isHidden = showOnScroll && !isScrolled;

    return (
      <div
        aria-hidden={isHidden || undefined}
        className={cx(styles.content, isHidden && styles.hidden, className)}
        data-core-ui-header-slot="content"
        data-core-ui-visible-on={visibleOn}
        ref={ref}
        {...rest}
      >
        {children}
      </div>
    );
  }),
);

HeaderContent.displayName = 'Header.Content';
